var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition-group",
    {
      ref: "list",
      attrs: { duration: _vm.duration },
      on: {
        "before-enter": _vm.beforeEnter,
        "before-leave": _vm.beforeLeave,
        "after-enter": _vm.clearStyles,
        "after-leave": _vm.clearStyles
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }